
































































import { defineComponent, PropType } from '@vue/composition-api';
import { SmartBidType } from '@tt4b/ttam-enums';
import StrategyPopover from '../strategy-popover/index.vue';
import { StrategyOption } from '../consts';
const name = 'ttam-bid-strategy-radios';

export default defineComponent({
  name,
  components: {
    StrategyPopover,
  },
  props: {
    value: {
      type: Number as PropType<SmartBidType>,
      required: true,
    },
    options: {
      type: Array as PropType<StrategyOption[]>,
      required: true,
    },
    learnMore: {
      type: Function,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => function () {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltipDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit, slots }) {
    function handleInnerClick(e) {
      // 选区调整为了防止冒泡触发重复 emit，需要这里 disable 掉 radio 的 click 事件
      e.preventDefault();
    }

    function handleRadioClick(item) {
      if (props.disabled) {
        return;
      }
      emit('input', item.value);
      emit('change', item.value);
    }

    return {
      name,
      handleInnerClick,
      handleRadioClick,
      slots,
    };
  },
});
